export const qualtricsStorageKey = '@pc-qualtrics'
export const defaultTechSolution = 'Platform Console'
